<template>
    <div>
        <v-card class="mx-auto pa-5 mt-5" style="max-width: 600px">
            <div v-if="showForm">
                <div class="text-h5 my-3 text-center">Password Reset</div>
                <PasswordResetForm
                    :user="$page.props.user"
                    :token="$page.props.token"
                    @password-reset-success="handleSuccessPasswordReset"
                />
            </div>
            <div v-else>
                <v-alert type="success"
                    >Your password has successfully been reset. Please return to
                    the login page by clicking
                    <Link
                        :href="route('index')"
                        class="text-decoration-underline"
                        >here</Link
                    >
                </v-alert>
            </div>
        </v-card>
    </div>
</template>

<script>
import PasswordResetForm from "../../components/Auth/Forms/PasswordResetForm.vue";
import GuestLayout from "../../Layouts/GuestLayout";
import { Link } from "@inertiajs/inertia-vue3";

export default {
    name: "PasswordReset",
    layout: [GuestLayout],
    components: { PasswordResetForm, Link },
    data() {
        return {
            showForm: true,
        };
    },
    methods: {
        handleSuccessPasswordReset() {
            this.showForm = false;
        },
    },
};
</script>

<style scoped></style>
